module.exports = __webpack_public_path__ + "static/media/pre-dorset_text_01.09530db0.jpg";